import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ProjectSeoService } from 'src/app/services/projectseo.service';
import { environment } from 'src/environments/environment';
import { ApicallService } from 'src/app/services/apicall.service';
import { NgxSpinnerService } from "ngx-spinner";
import { CommonService } from '../components/service/common.service';
@Component({
  selector: 'app-kidzee-partner',
  templateUrl: './kidzee-partner.component.html',
  styleUrls: ['./kidzee-partner.component.css']
})
export class KidzeePartnerComponent implements OnInit {
  isPopupVisible = false;
  utm_source: string = "Website";
  utm_medium: string = "Website";
  utm_compaign: string = "Website";
  gclid: string = "Website";
  utm_term: string = "Website";
  utm_content: string = "Website";
  utm_ad: string = "Website";
  customOptions: any = {
    loop: true,
    margin: 10,
    nav: true,
    dots: false,
    autoplay: true,
    autoplayTimeout: 3000,
    navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 4
      },
      1000: {
        items: 4
      }
    },
  }

  customOptions1: any = {
    loop: true,
    margin: 10,
    nav: true,
    dots: false,
    autoplay: true,
    autoplayTimeout: 3000,
    navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
    responsive: {
      0: {
        items: 4
      },
      600: {
        items: 4
      },
      1000: {
        items: 4
      }
    },
  }
  scrollPosition: any;
  otp_ValidMsg: boolean = false
  otp_inValidMsg: boolean = false
  submitted: boolean = false
  admissionForm: FormGroup;
  otpInput: boolean = false
  randomOtp: any;
  countryList: any;
  stateList: any;
  cityList: any = [];
  franchiseeList: any;


  popupObj = [
    {
      "id": 1,
      "title": 'India’s largest pre-school chain',
      "icon": 'https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kad1.png',
      "text": "Kidzee is India’s largest award-winning pre-school chain with an expertise spanning 20 years, over 2,000 centres in 750+ cities in India enriching over 1.4 million young minds."
    },
    {
      "id": 2,
      "title": 'Proven Business Model',
      "icon": 'https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kad2.png',
      "text": "A high-return, low-cost business model enables you to shape the young minds of tomorrow today while ensuring stability and opportunity to scale your franchise."
    },
    {
      "id": 3,
      "title": 'Market leader with a strong brand recall and brand lineage of 20 years',
      "icon": 'https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kad3.png',
      "text": "Kidzee pre-schools have consistently raised the standards for early education by meticulous effort that has stood the test of time for over 20 years."
    },
    {
      "id": 4,
      "title": 'Most awarded pre-school in the category',
      "icon": 'https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kad4.png',
      "text": "Kidzee with over two decades of expertise has won several awards such as India's Most Trusted Pre-school: TRA's Brand Trust Report, 2022 and more."
    },
    {
      "id": 5,
      "title": '4 layers of support',
      "icon": 'https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kad5.png',
      "text": "Your Kidzee franchise is backed by a robust 4-layered localised support system, guided by a team of 50+ dedicated territory and academic managers."
    },
    {
      "id": 6,
      "title": 'Most advanced curriculum',
      "icon": 'https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kad6.png',
      "text": "Launched in 2022, Kidzee’s newest Péntemind curriculum focuses on a five-fold approach to enrich young minds."
    },
    {
      "id": 7,
      "title": 'Best-in-class pedagogy',
      "icon": 'https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kad7.png',
      "text": "Péntemind, our revolutionary new curriculum helps children discover their unique learning style and achieve the desired learning outcomes, in sync with the high-level social, emotional, linguistic, and other developmental milestones."
    },
    {
      "id": 8,
      "title": 'Operational and Academic Support',
      "icon": 'https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kad8.png',
      "text": "Kidzee partners with you to drive admissions through comprehensive marketing strategies, parent seminars, and counsellor training. It offers localised support through a team of 50+ Territory Managers, ensuring specialised assistance."
    },
    {
      "id": 9,
      "title": 'Training',
      "icon": 'https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kad9.png',
      "text": "Over 10,000 teachers have been trained for over 80 hours to enable them to empower children as per their individual needs. Counsellors receive insightful training to help both the child and their parents."
    },
    {
      "id": 10,
      "title": 'e-Kidzee',
      "icon": 'https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kad10.png',
      "text": "Kidzee's business management platform helps reduce paperwork, making your franchise efficient from Day 1."
    },
    {
      "id": 11,
      "title": 'Layout Plan',
      "icon": 'https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kad11.png',
      "text": "Kidzee provides on-site visits or virtual consultations to guide franchise owners through infrastructure planning and implementation.By offering step-by-step guidance, Kidzee ensures that franchise owners can efficiently set up their preschool while maintaining quality, safety, and branding consistency."
    },
    {
      "id": 12,
      "title": 'Project Support',
      "icon": 'https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kad12.png',
      "text": "We collaborate closely with you during the launch, providing digital promotion and post-launch coverage. Additionally, we offer comprehensive support with brand guidelines, colour schemes, and admissions assistance to ensure a smooth and successful launch."
    }
  ]
  popupObjList: any = [];


  constructor(private _router: Router, private fb: FormBuilder, private ngxSpinner: NgxSpinnerService, private _servie: CommonService, private _activeRoute: ActivatedRoute, private router: Router,
    private projectService: ProjectSeoService,
    private apiService: ApicallService) {
    this.admissionForm = fb.group({
      fname: ['', Validators.required],
      lname: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      mobile: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      pinCode: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{6}$")]],
      state: ['', Validators.required],
      city: ['', Validators.required],
      otp: ['', Validators.required],

    })
  }


  ngOnInit(): void {
    this._activeRoute.queryParams.subscribe((params: Params) => {
      this.utm_source = params["utm_source"] != null ? params["utm_source"] : this.utm_source;
      this.utm_medium = params["utm_medium"] != null ? params["utm_medium"] : this.utm_medium;
      this.utm_compaign = params["utm_campaign"] != null ? params["utm_campaign"] : this.utm_compaign;
      this.gclid = params["gclid"] != null ? params["gclid"] : this.gclid;
      this.utm_term = params["utm_term"] != null ? params["utm_term"] : this.utm_term;
      this.utm_content = params["utm_content"] != null ? params["utm_content"] : this.utm_source;
      this.utm_ad = params["utm_ad"] != null ? params["utm_ad"] : this.utm_ad;
    });
    this.selectCountry_State_cityList();
  }

  scrollTo(section: string) {
    const element = document.getElementById(section);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  gotPage(val: any) {
    this.scrollTo(val)
    document.getElementById("trigger-overlay")?.click();
  }

  get f() {
    return this.admissionForm.controls;
  }

  validationForm() {
    this.submitted = true;
    if (this.admissionForm.invalid) {
      return;
    } else {
      this.submitForm()
    }

  }

  submitForm() {
    if ((this.admissionForm.get('otp')?.value).length == 4) {
      if (this.randomOtp == this.admissionForm.get('otp')?.value) {
        this.ngxSpinner.show();
        let obj = {
          "City": this.admissionForm.get('city')?.value,
          "Country": "India",
          "Email": this.admissionForm.get('email')?.value,
          "FirstName": this.admissionForm.get('fname')?.value,
          "HaveSpace": "",
          "LastName": this.admissionForm.get('lname')?.value,
          "Location": "",
          "Mobile": this.admissionForm.get('mobile')?.value,
          "PinCode": this.admissionForm.get('pinCode')?.value,
          "Product": "259262000001186013",
          "ProjectId": "1",
          "SoonStartsIn": "",
          "gclid": "gclid",
          "State": this.admissionForm.get('state')?.value,
          "Type": "F",
          "WillingToInvest": "",
          "Source": this.utm_source,
          "utm_compaign": this.utm_compaign,
          "utm_medium": this.utm_medium,
          "utm_source": this.utm_source,
          "utm_ad": this.utm_ad,
          "utm_content": this.utm_content,
          "utm_Term": this.utm_term,
        }
        this._servie.savefranchiseeData(obj).subscribe(
          res => {
            this.ngxSpinner.hide();
            this.otp_ValidMsg = false;
            this.otp_inValidMsg = false;
            this.router.navigate(['kidzee-partner/thankyou'])
            this.admissionForm.reset();
            this.submitted = false
          },
          error => {
            this.ngxSpinner.hide();
            console.log(error);
          }
        )
        this.otp_ValidMsg = true;
        this.otp_inValidMsg = false;

      } else {
        alert('Please Enter Valid OTP')
        this.otp_inValidMsg = true;
        this.otp_ValidMsg = false;
      }
    }


  }
  getMobileNO() {
    console.log(this.admissionForm.get('mobile')?.value)
    if ((this.admissionForm.get('mobile')?.value).length == 10) {
      this.sendMobNO();
    }
  }

  sendMobNO() {
    this.ngxSpinner.show();
    this.randomOtp = Math.floor(1000 + Math.random() * 9000);
    let mobNo = {
      "MobileNo": this.admissionForm.get('mobile')?.value,
      "smsText": `Your Kidzee Verification code is : ${this.randomOtp}`,
      "sResponse": ""
    }
    this._servie.getOtp(mobNo).subscribe(
      res => {
        this.ngxSpinner.hide();
        this.otpInput = true;
      },
      error => {
        this.ngxSpinner.hide();
        console.log(error);
      }
    )
  }

  verifyOTP() {
    if ((this.admissionForm.get('otp')?.value).length == 4) {
      if (this.randomOtp == this.admissionForm.get('otp')?.value) {
        this.otp_ValidMsg = true;
        this.otp_inValidMsg = false;
      } else {
        this.otp_inValidMsg = true;
        this.otp_ValidMsg = false;
      }
    }
  }

  selectCountry_State_cityList() {
    console.log('call city1');
    this._servie.getState_countryList().subscribe(
      res => {
        console.log('res', res);
        this.countryList = res.root.subroot
        console.log('call city2', this.countryList);
        let filterState = this.countryList.filter((x: any) => {
          return x.Country_Name == "India"
        })
        this.stateList = filterState[0].State
        console.log('stateList', this.stateList);
      })
    // this.getseo();
  }

  selectState(selectVal: any) {
    let state = selectVal.target.value
    let filterCity = this.stateList.filter((x: any) => {
      return x.State_Name == state
    })
    this.cityList = Array.isArray(filterCity[0].City)
      ? filterCity[0].City
      : [filterCity[0].City];

    console.log('cityList1', this.cityList);
    console.log('cityList2', this.cityList.length);
  }

  selectCity(selectVal: any) {
    let city = selectVal.target.value
    let filterFranchisee = this.cityList.filter((x: any) => {
      return x.City_Name == city
    })
    this.franchiseeList = filterFranchisee[0].Franchisee
  }


  openPopup(event: Event, id: any): void {
    event.preventDefault();  // Prevent the default scrolling behavior
    this.popupObjList = this.popupObj
    this.popupObjList = this.popupObj.filter((x: any) => {
      return x.id == id
    })
    console.log('popupObj', this.popupObjList);
    this.isPopupVisible = true;

  }

  closePopup(): void {
    // Close the popup
    this.isPopupVisible = false;
  }
}
